import React from 'react';
import { useTranslation } from 'react-i18next';
import { getNumberWithTierSuffix } from 'utils/stringUtils';
import { RoiServiceMetric } from '../types';
import RankedBarList from './RankedBarList';

interface Props {
  services: RoiServiceMetric[];
}

const TopServicesByVolume: React.FC<Props> = ({ services }) => {
  const { t } = useTranslation('admin');

  const items = services.slice(0, 8).map(s => ({
    label: s.serviceName,
    value: s.total,
    displayValue: getNumberWithTierSuffix(s.total),
  }));

  return (
    <div className="roi-panel">
      <h3 className="roi-panel-title">{t('roiInsights.panels.topByVolume')}</h3>
      {items.length === 0 ? (
        <div className="roi-panel-empty">{t('roiInsights.noData')}</div>
      ) : (
        <RankedBarList items={items} barColor="#a78bfa" />
      )}
    </div>
  );
};

export default TopServicesByVolume;
